export enum DocumentTypesEnum {
    PASSPORT = "PASSPORT",
    ID_CARD = "ID_CARD",
    CERTIFICATE = "CERTIFICATE"
}